import { render } from "./ArgonSnackbar.vue?vue&type=template&id=2c4d278a&scoped=true"
import script from "./ArgonSnackbar.vue?vue&type=script&lang=js"
export * from "./ArgonSnackbar.vue?vue&type=script&lang=js"

import "./ArgonSnackbar.vue?vue&type=style&index=0&id=2c4d278a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4d278a"]])

export default __exports__